
import { createAction } from 'redux-actions'

export const SET_CURRENT_PAGE_NAME = 'SET_CURRENT_PAGE_NAME'

export const setCurrentPageName = createAction(SET_CURRENT_PAGE_NAME)



// WEBPACK FOOTER //
// ./actions/current-page.js